import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import AppSection from '@/pages/home/components/AppSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CardsSection from '@/pages/home/components/CardsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <CarouselSection />
        <MediaSection />
        <FeaturesSection />
        <AppSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <AboutSection />
        <RankingSection />
        <FaqSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}